import {
    BonusNightProduct,
    Cart,
    FlightProduct,
    Product,
    ProductType,
} from '@/api/Cart/cart.interfaces';
import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';

function hasProductType(cart: Cart, type: ProductType): boolean {
    return Boolean(cart.Products.find((x) => x.Type === type));
}

export function hasHotelProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Hotel);
}

export function hasFlightProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Flight);
}

export function hasActivityProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Activity);
}

function hasGolfProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Golf);
}

function hasTrainProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Train);
}

export function hasFerryProduct(cart: Cart): boolean {
    return hasProductType(cart, ProductType.Ferry);
}

export function isFlightOnly(cart: Cart): boolean {
    return (
        hasFlightProduct(cart) &&
        !hasActivityProduct(cart) &&
        !hasFerryProduct(cart) &&
        !hasHotelProduct(cart) &&
        !hasGolfProduct(cart) &&
        !hasTrainProduct(cart)
    );
}

export function isHotelOnly(cart: Cart): boolean {
    return (
        hasHotelProduct(cart) &&
        !hasActivityProduct(cart) &&
        !hasFerryProduct(cart) &&
        !hasFlightProduct(cart) &&
        !hasGolfProduct(cart) &&
        !hasTrainProduct(cart)
    );
}

export function isActivityOnly(cart: Cart): boolean {
    return (
        hasActivityProduct(cart) &&
        !hasHotelProduct(cart) &&
        !hasFerryProduct(cart) &&
        !hasFlightProduct(cart) &&
        !hasGolfProduct(cart) &&
        !hasTrainProduct(cart)
    );
}

export function isFerryOnly(cart: Cart): boolean {
    return (
        hasFerryProduct(cart) &&
        !hasFlightProduct(cart) &&
        !hasActivityProduct(cart) &&
        !hasHotelProduct(cart) &&
        !hasGolfProduct(cart) &&
        !hasTrainProduct(cart)
    );
}

export function getProductIcon(type: ProductType): IconType | undefined {
    switch (type) {
        case ProductType.Hotel:
            return 'Bed';
        case ProductType.Flight:
            return 'Plane';
        case ProductType.Ferry:
            return 'Ferry';
        case ProductType.Activity:
            return 'Ticket';
        case ProductType.Golf:
            return 'Golf';
        default:
            return undefined;
    }
}

export function cartHasRyanair(products: FlightProduct[]): boolean {
    return products.some((p) => cartProductHasRyanair(p));
}

export function cartProductHasRyanair(product: FlightProduct): boolean {
    return hasCarrier(product, 'FR');
}

function hasCarrier(product: FlightProduct, carrierCode: string): boolean {
    return product.Legs.some((x) => x.PlatingCarrier === carrierCode);
}

export function isBonusNightProduct(p: Product): p is BonusNightProduct {
    return p.Type === ProductType.Discount && 'AppliedBonusNights' in p;
}
